import CollectRecordFormPage from './CollectRecordFormPage'

export default CollectRecordFormPage
